import React, { useState, useEffect } from 'react';
import { Portal } from 'react-portal';
import { Container, MainTitle, TextBl, Subtit, VideoReviewDiv,ImageBorder, BorderPlay ,ButtonC } from './styles';



import VideoPopup from '../VideoPopup';
import previewVideo from '../../static/previewVideo.jpg';


const VideoReview = () => {
  const [onPlay, setOnPlay] = useState(false);

  useEffect(() => {
    // change later
    console.log(
      '%c ',
      `font-size:10px; background:url(https://s.dou.ua/CACHE/images/img/static/companies/new_logo_fulcrum/8b3d91820998ecd5cd9dac3e5ead6982.png) no-repeat; padding: ${(70 /
        100) *
        100}px ${(200 / 100) * 100}px;`,
    );

    console.log(`And what are you looking for a little bandit?
                https://jobs.dou.ua/companies/fulcrum/vacancies/`);
  }, []);
  const togglePopup = () => {
    const { body } = document;

    setOnPlay(!onPlay);
    onPlay
      ? body.setAttribute('style', 'overflow-y:auto')
      : body.setAttribute('style', 'overflow-y:hidden');
  };
  return (
    <>
      <Container>
      <MainTitle style={{textAlign: 'center',marginBottom: '3rem'}}>What’s lean canvas? </MainTitle>
        
      <VideoReviewDiv>
          <ImageBorder src={previewVideo} />
          <BorderPlay onClick={() => togglePopup()}>
            <svg
              style={{ position: 'relative', left: '0.2rem', zIndex: 1 }}
              width="20"
              height="30"
              viewBox="0 0 29 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 19L2.46316e-07 38L1.90735e-06 -1.26763e-06L29 19Z"
                fill="white"
              />
            </svg>
          </BorderPlay>
        </VideoReviewDiv>
        <TextBl>
          <Subtit>
            {`Lean Canvas is an adapted version of Business Canvas model by Alex Osterwalder. The basic difference – Lean Canvas is more focused on startups. it helps you turn your killer idea into life. When you fill in Lean Canvas, try to be as specific as possible. Every detail matters.\n\nHere are quick instructions how to fill in your Lean Canvas. `}
          </Subtit>
          <ButtonC target="_blank" href='https://fulcrum.rocks/blog/fill-in-lean-canvas/'>Read article</ButtonC>
        </TextBl>
        
      </Container>
      {onPlay && (
        <Portal>
          <VideoPopup
            togglePopup={() => togglePopup()}
            link="https://www.youtube.com/embed/GjPDJFaaNyg?rel=0"
          />
        </Portal>
      )}
    </>
  );
};

export default VideoReview;
